/* Inline cart logic — één bron van waarheid, werkt ook na section reloads */
(function () {
  function ready(fn) {
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);
  }

  const SS_CART_FLASH_KEY = 'ss_cart_flash_v1';
  const SS_SHIPPING_COUNTRY_KEY = 'ss_cart_shipping_country_v1';
  const SS_B2B_BUNDLE_PROP_KEYS = [
    '_ss_b2b_bundle_id',
    '_ss_b2b_print_group_id',
    '_ss_b2b_role',
    '_ss_b2b_parent_product_id',
    '_ss_b2b_parent_variant_id',
    '_ss_b2b_shadow_product_id',
    '_ss_b2b_shadow_variant_id',
    '_ss_b2b_config_hash',
    '_ss_b2b_image_url',
  ];

  function byId(id) {
    return document.getElementById(id);
  }

  // Mini-modal voor minimale afname (zelfde gedrag als offerte)
  function showCartMinModal(message) {
    var modal = byId('ssCartMinModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'ssCartMinModal';
      modal.className = 'ss-cart-minmodal';
      modal.innerHTML =
        '<div class="ss-cart-minmodal__backdrop" data-ss-cart-minmodal-close></div>' +
        '<div class="ss-cart-minmodal__dialog" role="alertdialog" aria-modal="true">' +
        '  <div class="ss-cart-minmodal__body">' +
        '    <p class="ss-cart-minmodal__text"></p>' +
        '    <button type="button" class="btn accent ss-cart-minmodal__btn" data-ss-cart-minmodal-close>OK</button>' +
        '  </div>' +
        '</div>';
      document.body.appendChild(modal);

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-ss-cart-minmodal-close]')) {
          modal.setAttribute('hidden', 'hidden');
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) {
          modal.setAttribute('hidden', 'hidden');
        }
      });
    }

    var textEl = modal.querySelector('.ss-cart-minmodal__text');
    if (textEl) textEl.textContent = String(message || '').trim();
    modal.removeAttribute('hidden');
  }

  function ssCartStoreFlash(payload) {
    try {
      const data = {
        token: payload && payload.token ? String(payload.token) : '',
        mainKey: payload && payload.mainKey ? String(payload.mainKey) : '',
        t: Date.now(),
      };
      sessionStorage.setItem(SS_CART_FLASH_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function ssCartApplyFlash() {
    let raw = null;

    try { raw = sessionStorage.getItem(SS_CART_FLASH_KEY); } catch (e0) { return; }
    if (!raw) return;

    // voorkom loops als de selector faalt
    try { sessionStorage.removeItem(SS_CART_FLASH_KEY); } catch (e1) {}

    let data = null;
    try { data = JSON.parse(raw); } catch (e2) { return; }
    if (!data) return;

    // verlopen? (bijv. iemand navigeert later terug)
    if (data.t && (Date.now() - Number(data.t)) > 30000) return;

    const token = String(data.token || '');
    const mainKey = String(data.mainKey || '');

    let target = null;

    if (token) {
      target = document.querySelector(
        `cart-item.ss-cart-item[data-config-id="${CSS.escape(token)}"]`
      );
    }

    if (!target && mainKey) {
      const btn = document.querySelector(
        `button.js-ss-edit[data-item-key="${CSS.escape(mainKey)}"]`
      );
      target = btn ? btn.closest('cart-item.ss-cart-item') : null;
    }

    if (!target) return;

    // Zorg dat het aangepaste item altijd in beeld komt,
    // ook als Shopify de volgorde van cart.items wijzigt.
    // Scroll iets verder door zodat er ~30px ruimte boven het product is.
    try {
      const rect = target.getBoundingClientRect();
      const offset = 30; // px ruimte boven het item
      const top = Math.max(window.pageYOffset + rect.top - offset, 0);
      window.scrollTo({ top, behavior: 'smooth' });
    } catch (e) {
      try { target.scrollIntoView(); } catch (e2) {}
    }

    target.classList.remove('ss-cart-item--flash');
    void target.offsetWidth; // reflow zodat hij opnieuw kan animeren
    target.classList.add('ss-cart-item--flash');

    target.addEventListener(
      'animationend',
      function () {
        target.classList.remove('ss-cart-item--flash');
      },
      { once: true }
    );
  }


    ready(function () {

      ssCartApplyFlash();

      function ssApplyPctToCents(cents, pct) {
        const base = Math.round(Number(cents) || 0);
        const p = Math.max(0, Math.min(100, Number(pct) || 0));
        const bp = Math.round(p * 100);       // 0..10000
        const factorBp = 10000 - bp;

        if (typeof BigInt === "function") {
          const b = BigInt(base);
          const f = BigInt(factorBp);
          return Number((b * f + 5000n) / 10000n);
        }

        return Math.round(base * (1 - p / 100));
      }

    const form = document.getElementById('cart_form');
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

  // Fancybox: cart-foto's klikbaar (zelfde als offerte)
  try {
    if (window.Fancybox && typeof window.Fancybox.bind === 'function') {
      window.Fancybox.bind('a[data-fancybox="cart-media"]', {
        Thumbs: false,
      });
    }
  } catch (e) {}


    const int = (v) => {
      const n = parseInt(String(v || ''), 10);
      return Number.isFinite(n) ? n : 0;
    };

    const apply = (updates) =>
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      }).then((r) => r.json());

    async function changeCartLine(line, quantity) {
      const lineNumber = int(line);
      if (!lineNumber) throw new Error('Cart-regel niet gevonden.');

      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineNumber, quantity: int(quantity) }),
      });

      if (!r.ok) {
        let msg = 'Winkelwagen aanpassen mislukt.';
        try {
          const j = await r.json();
          msg = j?.description || j?.message || msg;
        } catch {}
        throw new Error(msg);
      }

      return r.json();
    }

    function ssHideLegacyTechForProperty(props) {
      const next = Object.assign({}, props || {});
      let changed = false;

      if (Object.prototype.hasOwnProperty.call(next, 'tech_for')) {
        if (!next._tech_for) next._tech_for = next.tech_for;
        delete next.tech_for;
        changed = true;
      }

      return { changed, properties: next };
    }

    async function ssCleanupVisibleTechForProperties() {
      let cart;
      try {
        cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      } catch {
        return;
      }

      const dirtyLines = (cart.items || [])
        .map((it) => {
          const normalized = ssHideLegacyTechForProperty(it.properties || {});
          return normalized.changed
            ? { key: it.key, quantity: it.quantity, properties: normalized.properties }
            : null;
        })
        .filter(Boolean);

      if (!dirtyLines.length) return;

      let changed = false;
      for (const line of dirtyLines) {
        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(line),
          });
          if (res.ok) changed = true;
        } catch {}
      }

      if (changed) location.reload();
    }

    ssCleanupVisibleTechForProperties().catch(() => {});


    // -----------------------------
    // Verder winkelen / meer producten toevoegen:
    // liever terug naar de vorige pagina (referrer) dan /collections/all
    // Fallback is gewoon de href (meestal home).
    // -----------------------------
    (function initContinueShoppingLinks() {
      const links = document.querySelectorAll('[data-ss-continue-shopping]');
      if (!links.length) return;

      // fallback = href van de eerste (meestal /)
      let fallback = links[0].getAttribute('href') || '/';
      try { fallback = new URL(fallback, window.location.origin).href; } catch {}

      let target = fallback;
      const ref = document.referrer;

      try {
        if (ref) {
          const u = new URL(ref);
          if (u.origin === window.location.origin && !u.pathname.startsWith('/cart')) {
            target = u.href;
          }
        }
      } catch {}

      links.forEach((a) => {
        a.addEventListener('click', (ev) => {
          // new tab / modifier keys moeten gewoon werken
          if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
          ev.preventDefault();
          window.location.href = target;
        });
      });
    })();

    // -----------------------------
    // VAT info language toggle
    // -----------------------------
    (function initVatInfoLanguageToggle() {
      const wrap = document.querySelector('[data-ss-vat-info]');
      if (!wrap) return;

      const toggle = wrap.querySelector('[data-ss-vat-lang-toggle]');
      if (!toggle) return;

      const setLanguage = (lang) => {
        wrap.querySelectorAll('[data-ss-vat-lang]').forEach((el) => {
          el.hidden = el.getAttribute('data-ss-vat-lang') !== lang;
        });

        const nextLang = lang === 'nl' ? 'EN' : 'NL';
        toggle.textContent = nextLang;
        toggle.setAttribute(
          'aria-label',
          lang === 'nl'
            ? 'Show this VAT information in English'
            : 'Toon deze btw-informatie in het Nederlands'
        );
        toggle.setAttribute('aria-pressed', lang === 'en' ? 'true' : 'false');
      };

      toggle.addEventListener('click', () => {
        const isEnglish = toggle.getAttribute('aria-pressed') === 'true';
        setLanguage(isEnglish ? 'nl' : 'en');
      });

      setLanguage('nl');
    })();

    // -----------------------------
    // Failsafe: verwijder schaduwregels (Bedrukkingskosten) bij producten zonder drukopties
    // (voorkomt verkeerde totalen + schaduwproduct in checkout)
    // -----------------------------
    async function ssCleanupShadowForNonPrintable() {
      const FLAG = 'ss_shadow_cleanup_done';
      if (sessionStorage.getItem(FLAG) === '1') return;

      // Bepaal welke hoofdproducten géén drukopties hebben (techniques JSON is leeg)
      const nonPrintableProductIds = new Set();
      const nonPrintableCfgIds = new Set();

      document.querySelectorAll('cart-item.ss-cart-item').forEach((ci) => {
        const pid = String(ci.dataset.productId || '');
        const cfg = String(ci.dataset.configId || '');

        const techEl = ci.querySelector('[data-ss-edit-techniques]');
        if (!techEl) return;

        try {
          const list = JSON.parse(techEl.textContent || '[]');
          if (Array.isArray(list) && list.length === 0) {
            if (pid) nonPrintableProductIds.add(pid);
            if (cfg) nonPrintableCfgIds.add(cfg);
          }
        } catch {}
      });

      if (!nonPrintableProductIds.size && !nonPrintableCfgIds.size) return;

      // Lees cart en verwijder schaduwregels die aan zo’n non-printable product gekoppeld zijn
      let cart;
      try {
        cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
      } catch {
        return;
      }

      const updates = {};
      (cart.items || []).forEach((it) => {
        const props = it.properties || {};
        const cfg = String(props._config_sub || props.config_sub || '');
        if (!cfg) return;

        const techFor = String(props._tech_for || props.tech_for || '');

        // 1) hard koppeling via tech_for (product_id)
        if (techFor && nonPrintableProductIds.has(techFor)) {
          updates[it.key] = 0;
          return;
        }

        // 2) fallback: gekoppeld via config id (als hoofditem wél een cfg heeft)
        if (cfg && nonPrintableCfgIds.has(cfg)) {
          updates[it.key] = 0;
        }
      });

      const keys = Object.keys(updates);
      if (!keys.length) return;

      sessionStorage.setItem(FLAG, '1');
      await apply(updates);
      location.reload();
    }

    ssCleanupShadowForNonPrintable().catch(() => {});
    const setSelectedText = (cq, text) => {
      const el = cq?.querySelector('.standard-select__selected--text');
      if (el) el.textContent = text;
    };

    const toggleFreeInput = (cq, show) => {
      const wrap = cq?.querySelector('.quantity-free-input');
      if (!wrap) return;
      wrap.style.display = show ? 'block' : 'none';

      if (show) cq.querySelector('input.diff-amount')?.focus();
      if (!show) {
        const input = cq.querySelector('input.diff-amount');
        if (input) input.value = '';
      }
    };

    const showMinErrorForProduct = (productId) => {
      const pid = String(productId || '');
      if (!pid) return;

      document
        .querySelectorAll(
          `cart-item[data-product-id="${CSS.escape(pid)}"] .minimum-quantity-error`
        )
        .forEach((el) => {
          el.style.display = 'block';
          clearTimeout(el._ssMinT);
          el._ssMinT = setTimeout(() => {
            el.style.display = 'none';
          }, 9000);
        });
    };

    // -----------------------------
    // Vaste aantallen (quantity_options): alleen deze aantallen toestaan
    // -----------------------------
    function parseJsonSafe(str, fallback) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return fallback;
      }
    }

    function getFixedQtyOptionsFromCQ(cq) {
      const ci = cq?.closest('cart-item');
      if (!ci) return [];
      const strict = String(ci.dataset.ssQtyOptionsStrict || '').toLowerCase();
      const isStrict = strict === '1' || strict === 'true';
      if (!isStrict) return [];

      // 1) Primair: parse uit data-ss-qty-options
      let arr = [];
      const raw = ci.dataset.ssQtyOptions;
      if (raw) {
        const parsed = parseJsonSafe(raw, []);
        if (Array.isArray(parsed)) arr = parsed;
      }

      const normalize = (list) => {
        const out = [];
        const seen = new Set();
        for (const v of list || []) {
          const n = int(v);
          if (!n || n < 0) continue;
          if (seen.has(n)) continue;
          seen.add(n);
          out.push(n);
        }
        out.sort((a, b) => a - b);
        return out;
      };

      let allowed = normalize(arr);

      // 2) Fallback: lees uit de huidige <select> opties (als data ontbreekt/lege lijst)
      if (!allowed.length) {
        const sel = cq?.querySelector('select[name^="updates["]');
        if (sel) {
          const fromSelect = [];
          for (const opt of Array.from(sel.options || [])) {
            const v = String(opt.value || '').trim();
            if (!v || v === 'other') continue;
            const n = int(v);
            if (n) fromSelect.push(n);
          }
          allowed = normalize(fromSelect);
        }
      }

      return allowed;
    }

    function showFixedQtyErrorForProduct(productId, allowed) {
      const ci = document.querySelector(`cart-item[data-product-id="${productId}"]`);
      if (!ci) return;
      const el = ci.querySelector('.fixed-quantity-error');
      if (!el) return;

      const msg = allowed?.length
        ? `Kies één van: ${allowed.join(', ')}`
        : 'Kies een geldig aantal.';

      el.textContent = msg;
      el.style.display = 'block';
      setTimeout(() => {
        el.style.display = 'none';
      }, 9500);
    }

    function initFixedQtyUI() {
      document.querySelectorAll('cart-quantity').forEach((cq) => {
        const ci = cq?.closest('cart-item');
        if (!ci) return;

        const strict = String(ci.dataset.ssQtyOptionsStrict || '').toLowerCase();
        const isStrict = strict === '1' || strict === 'true';
        if (!isStrict) return;

        const allowed = getFixedQtyOptionsFromCQ(cq); // kan leeg zijn

        const sel = cq.querySelector('select[name^="updates["]');
        if (sel) {
          const currentQty = int(cq.dataset.currentQuantity) || int(sel.value) || 0;

          // Verwijder altijd "other" in strict mode
          // En (alleen als allowed beschikbaar is): verwijder opties die niet in allowed zitten
          [...sel.options].forEach((opt) => {
            const v = (opt.value || '').trim();

            if (v === 'other') {
              opt.remove();
              return;
            }

            if (allowed.length) {
              const n = int(v);
              if (n && !allowed.includes(n) && n !== currentQty) {
                opt.remove();
              }
            }
          });
        }

        // Zorg dat eventuele "other" input niet blijft hangen
        toggleFreeInput(cq, false);
        const otherInp = cq.querySelector('input[name="updates_other"]');
        if (otherInp) otherInp.value = '';
      });
    }


    const wouldViolateMin = (cq, newLineQty) => {
      if (!cq) return false;

      const min = int(cq.dataset.minimumQuantity);
      if (!min) return false;

      const currentTotal = int(cq.dataset.currentTotal);
      const currentLine = int(cq.dataset.currentQuantity);
      const newTotal = currentTotal - currentLine + int(newLineQty);

      return newTotal > 0 && newTotal < min;
    };

    const getCfgId = (el) =>
      el?.dataset?.configId ||
      el.closest('cart-item')?.querySelector('.item__remove')?.dataset.configId ||
      '';

    function showCartOverlay() {
      try {
        if (document.querySelector('#cart .ss-cart-overlay')) return;
        const root = byId('cart') || document.body;
        const wrap = document.createElement('div');
        wrap.className = 'ss-cart-overlay';
        const spinner = document.createElement('div');
        spinner.className = 'ss-cart-overlay__spinner';
        wrap.appendChild(spinner);
        root.appendChild(wrap);
      } catch (e) {}
    }

    // Verwijderen (hoofd + gekoppelde subregels)
    form.addEventListener('click', async function (e) {
      const a = e.target.closest('.item__remove');
      if (!a) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // MOQ check: als verwijderen ertoe leidt dat het totaal binnen de familie
      // (alle kleuren/maten) onder de minimale afname komt maar niet op 0 uitkomt,
      // blokkeren we de actie en tonen we dezelfde melding als bij qty-wijziging.
      const ci = a.closest('cart-item');
      const cq = ci?.querySelector('cart-quantity');
      if (wouldViolateMin(cq, 0)) {
        const min = int(cq?.dataset.minimumQuantity);
        if (min) {
          showCartMinModal(
            `${min} stuks is de minimale afname. Pas de aantallen aan tot minimaal ${min} stuks in totaal.`
          );
        } else {
          const pid = cq?.dataset.productId;
          if (pid) showMinErrorForProduct(pid);
        }
        return;
      }

      let updates = {};
      const mainKey = a.dataset.itemKey;
      const cfg = a.dataset.configId;
      const editBtn = ci?.querySelector('.js-ss-edit');

      const isTransformBundle = ci?.classList.contains('ss-cart-item--transform-bundle');

      if (isTransformBundle) {
        try {
          const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
          const resolved = resolveSsB2bBundleLines(cart, {
            mainKey,
            cfgId: cfg,
            productHandle: editBtn?.dataset.productHandle,
            variantId: editBtn?.dataset.variantId,
            subVariantId: editBtn?.dataset.subVariantId,
            qty: editBtn?.dataset.qty,
          });

          if (resolved.mainLine?.key) updates[resolved.mainLine.key] = 0;
          resolved.printLines.forEach((line) => {
            if (line.key) updates[line.key] = 0;
          });
        } catch (err) {
          console.error('Bundelregels opzoeken mislukt', err);
        }

        if (!Object.keys(updates).length) {
          const cartLine = int(a.dataset.cartLine || ci?.dataset.cartLine);
          if (cartLine) {
            showCartOverlay();
            try {
              await changeCartLine(cartLine, 0);
              location.reload();
            } catch (err) {
              console.error(err);
              if (a.href) window.location.href = a.href;
            }
            return;
          }

          if (a.href) {
            window.location.href = a.href;
            return;
          }
        }
      }

	      if (!Object.keys(updates).length && mainKey) updates[mainKey] = 0;

	      if (cfg) {
	        document
	          .querySelectorAll(
	            `[data-config-sub-input][data-config-id="${CSS.escape(cfg)}"]`
	          )
	          .forEach((inp) => {
	            if (inp.dataset.itemKey) updates[inp.dataset.itemKey] = 0;
	          });
	      }

      if (!Object.keys(updates).length) return;

      showCartOverlay();
      apply(updates).then(() => location.reload());
    });

    // Verwijder bedrukking (alle subregels op 0)
    form.addEventListener('click', async function (e) {
      const btn = e.target.closest('.js-remove-bedrukking');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const cfg = btn.dataset.configId || '';
      const subKey = btn.dataset.subKey || '';
      const ci = btn.closest('cart-item');
      const mainKey =
        btn.dataset.itemKey ||
        ci?.querySelector('.item__remove')?.dataset.itemKey ||
        ci?.querySelector('.js-ss-edit')?.dataset.itemKey ||
        '';

      const updatesZero = {};

      if (cfg) {
        document
          .querySelectorAll(
            `[data-config-sub-input][data-config-id="${CSS.escape(cfg)}"]`
          )
          .forEach((inp) => {
            updatesZero[inp.dataset.itemKey] = 0;
          });
      } else if (subKey) {
        updatesZero[subKey] = 0;
      }

      if (!Object.keys(updatesZero).length) return;

      showCartOverlay();

      if (!mainKey) {
        apply(updatesZero).then(() => location.reload());
        return;
      }

      try {
        const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
        const oldMainLine = cart.items.find((i) => i.key === mainKey);
        const oldSubLines = cfg
          ? (cart.items || []).filter((i) => {
              const props = i.properties || {};
              return String(props._config_sub || props.config_sub || '') === cfg;
            })
          : (subKey ? (cart.items || []).filter((i) => i.key === subKey) : []);

        if (!oldMainLine) {
          await apply(updatesZero);
          location.reload();
          return;
        }

        const token = randomToken();
        let newMainProps = stripUploadedBedrukkingProps(oldMainLine.properties || {});
        newMainProps = stripSsB2bBundleProps(newMainProps);

        delete newMainProps._config_sub;
        delete newMainProps.config_sub;
        delete newMainProps._config_main;
        delete newMainProps.config_main;
        newMainProps._config_main = token;

        updatesZero[mainKey] = 0;
        await apply(updatesZero);

        try {
          await cartAddItems([{
            id: int(oldMainLine.variant_id || oldMainLine.id),
            quantity: int(oldMainLine.quantity),
            properties: newMainProps
          }]);
        } catch (addErr) {
          try {
            const rollback = [{
              id: int(oldMainLine.variant_id || oldMainLine.id),
              quantity: int(oldMainLine.quantity),
              properties: Object.assign({}, oldMainLine.properties || {})
            }];

            oldSubLines.forEach((line) => {
              rollback.push({
                id: int(line.variant_id || line.id),
                quantity: int(line.quantity),
                properties: Object.assign({}, line.properties || {})
              });
            });

            await cartAddItems(rollback);
          } catch (rbErr) {
            console.error('Rollback mislukt', rbErr);
          }

          throw addErr;
        }

        ssCartStoreFlash({ token, mainKey });
        location.reload();
      } catch (err) {
        console.error(err);
        location.reload();
      }
    });

    // Aantal wijzigen (hoofd = sub)
    form.addEventListener('change', function (e) {
      const el = e.target;
      if (!el.name || !/^updates\[/.test(el.name)) return;

      const m = el.name.match(/^updates\[(.+)\]$/);
      if (!m) return;

      e.stopPropagation();
      e.stopImmediatePropagation();

      const cq = el.closest('cart-quantity');

      if (el.value === 'other') {
        toggleFreeInput(cq, true);

        const prev = cq?.dataset.currentQuantity;
        if (prev) {
          el.value = prev;
          setSelectedText(cq, prev);
        }
        return;
      }

      toggleFreeInput(cq, false);

      const key = m[1];
      const qty = int(el.value);

      const prev = cq?.dataset.currentQuantity;

      const fixedAllowed = getFixedQtyOptionsFromCQ(cq);
      if (fixedAllowed.length && qty > 0 && !fixedAllowed.includes(qty)) {
        showFixedQtyErrorForProduct(cq.dataset.productId, fixedAllowed);

        // terugzetten naar vorige waarde
        if (prev) {
          el.value = prev;
          setSelectedText(cq, prev);
        }
        return;
      }


      if (wouldViolateMin(cq, qty)) {
        const min = int(cq?.dataset.minimumQuantity);
        if (min) {
          showCartMinModal(
            `${min} stuks is de minimale afname. Pas de aantallen aan tot minimaal ${min} stuks in totaal.`
          );
        } else {
          showMinErrorForProduct(cq?.dataset.productId);
        }

        if (prev) {
          el.value = prev;
          setSelectedText(cq, prev);
        }
        return;
      }

      const updates = { [key]: qty };

      const cfg = getCfgId(el);
      if (cfg) {
        document
          .querySelectorAll(
            `[data-config-sub-input][data-config-id="${CSS.escape(cfg)}"]`
          )
          .forEach((inp) => {
            updates[inp.dataset.itemKey] = qty;
          });
      }

      apply(updates).then(() => location.reload());
    });

    // Groene vink bij “Anders, namelijk:”
    form.addEventListener('click', function (e) {
      const btn = e.target.closest('.submit-amount');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const cq = btn.closest('cart-quantity');
      const select = cq?.querySelector('select[name^="updates["]');
      const input = cq?.querySelector('input.diff-amount');

      if (!cq || !select || !input) return;

      const m = select.name.match(/^updates\[(.+)\]$/);
      if (!m) return;

      const qty = int(input.value);

      const fixedAllowed = getFixedQtyOptionsFromCQ(cq);
      if (fixedAllowed.length && qty > 0 && !fixedAllowed.includes(qty)) {
        showFixedQtyErrorForProduct(cq.dataset.productId, fixedAllowed);
        input.value = '';
        return;
      }

      if (!qty) return;

      if (wouldViolateMin(cq, qty)) {
        const min = int(cq?.dataset.minimumQuantity);
        if (min) {
          showCartMinModal(
            `${min} stuks is de minimale afname. Pas de aantallen aan tot minimaal ${min} stuks in totaal.`
          );
        } else {
          showMinErrorForProduct(cq.dataset.productId);
        }
        input.focus();
        return;
      }

      const key = m[1];
      const updates = { [key]: qty };

      const cfg = getCfgId(select);
      if (cfg) {
        document
          .querySelectorAll(
            `[data-config-sub-input][data-config-id="${CSS.escape(cfg)}"]`
          )
          .forEach((inp) => {
            updates[inp.dataset.itemKey] = qty;
          });
      }

      apply(updates).then(() => location.reload());
    });



    // -----------------------------
    // Eigen SS staffels uit metaobjects in cart UI tonen
    // -----------------------------
    function ssParseJSON(id) {
      const el = document.getElementById(id);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent || "{}");
      } catch {
        return null;
      }
    }

    function ssPickPct(qty, tiers) {
      if (!Array.isArray(tiers)) return 0;
      let best = 0;
      for (const r of tiers) {
        const min = parseInt(r.min ?? r.min_qty ?? r.quantity ?? 0, 10) || 0;
        const pct = Number(r.percent ?? r.pct ?? 0) || 0;
        if (qty >= min && pct >= best) best = pct;
      }
      return best;
    }

    function ssTierUnitCents(baseCents, qty, tiers) {
      const base = Math.round(Number(baseCents) || 0);
      if (!Array.isArray(tiers) || !tiers.length) return base;

      let best = base;
      for (const tier of tiers) {
        const min = parseInt(tier.min ?? tier.min_qty ?? tier.quantity ?? 0, 10) || 0;
        if (!min || qty < min) continue;

        let candidate = null;
        const fixedPrice = tier.price_cents ?? tier.priceCents ?? tier.fixed_price_cents;
        const fixedPriceDecimal = tier.price ?? tier.fixed_price;
        const fixedOff = tier.amount_off_cents ?? tier.amountOffCents ?? tier.fixed_off_cents;
        const fixedOffDecimal = tier.amount_off ?? tier.fixed_off;

        if (fixedPrice != null) {
          candidate = Math.round(Number(fixedPrice) || 0);
        } else if (fixedPriceDecimal != null) {
          const f = parseFloat(String(fixedPriceDecimal).replace(',', '.'));
          candidate = Number.isFinite(f) ? Math.round(f * 100) : null;
        } else if (fixedOff != null) {
          candidate = Math.max(0, base - Math.round(Number(fixedOff) || 0));
        } else if (fixedOffDecimal != null) {
          const f = parseFloat(String(fixedOffDecimal).replace(',', '.'));
          candidate = Number.isFinite(f) ? Math.max(0, base - Math.round(f * 100)) : null;
        } else {
          const pct = Number(tier.percent ?? tier.pct ?? 0) || 0;
          candidate = pct ? ssApplyPctToCents(base, pct) : base;
        }

        if (candidate != null && Number.isFinite(candidate) && candidate < best) {
          best = candidate;
        }
      }

      return best;
    }

    function ssIncFromEx(exCents, taxRate) {
      const taxFactor = 100 + (Number(taxRate) || 21); // 121
      const rounder = 50; // zelfde als Liquid (0,5 cent voor afronding)
      return Math.floor((exCents * taxFactor + rounder) / 100);
    }

    function ssMoney(cents, cfg) {
      const currency = cfg?.currency || "EUR";
      const moneyFormat = cfg?.moneyFormat;

      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        try {
          return moneyFormat ? Shopify.formatMoney(cents, moneyFormat) : Shopify.formatMoney(cents);
        } catch {}
      }
      // fallback
      return new Intl.NumberFormat("nl-NL", { style: "currency", currency }).format((cents || 0) / 100);
    }

    function ssShippingGoalCents(cfg, countryCode) {
      const country = String(countryCode || cfg?.shippingDefaultCountry || "NL").toUpperCase();
      const goals = cfg?.shippingGoalsByCountry || {};
      const fromCountry = parseInt(goals[country] || "0", 10) || 0;
      if (fromCountry > 0) return fromCountry;
      return country === "NL" ? (parseInt(cfg?.shippingGoalCents || "0", 10) || 0) : 0;
    }

    function ssShippingAlwaysFree(cfg, countryCode) {
      const country = String(countryCode || cfg?.shippingDefaultCountry || "NL").toUpperCase();
      return cfg?.shippingAlwaysFreeByCountry?.[country] === true;
    }

    function ssShippingBaseRateCents(cfg, countryCode) {
      const country = String(countryCode || cfg?.shippingDefaultCountry || "NL").toUpperCase();
      const rates = cfg?.shippingBaseRatesByCountry || {};
      const fromCountry = parseInt(rates[country] || "0", 10) || 0;
      if (fromCountry > 0) return fromCountry;
      if (country === "BE") return 1250;
      if (country === "DE") return 2500;
      return 950;
    }

    function ssFreeShippingProductDiscountPercent(cfg, countryCode) {
      const country = String(countryCode || cfg?.shippingDefaultCountry || "NL").toUpperCase();
      const discounts = cfg?.freeShippingProductDiscountPercentsByCountry || {};
      const percent = parseFloat(String(discounts[country] ?? "0").replace(",", "."));
      if (!Number.isFinite(percent)) return 0;
      return Math.max(0, Math.min(100, percent));
    }

    function ssFreeShippingProductNoteText(countryCode, discountPercent, shippingFree = false) {
      const country = String(countryCode || "NL").toUpperCase();
      if (country === "NL") return "GRATIS verzending in NL";
      if (country === "BE" && shippingFree) return "GRATIS verzending naar BE";
      if (country === "BE" && discountPercent > 0) return "50% korting op verzending naar BE";
      if (country === "DE" && shippingFree) return "GRATIS verzending naar DE";
      return "";
    }

    function ssShippingValueHtml(baseRateCents, free, cfg, discountPercent = 0) {
      if (free) {
        return `<span class="ss-cart-shipping-price-old">${ssMoney(baseRateCents, cfg)}</span><span class="ss-cart-shipping-free">GRATIS</span>`;
      }
      if (discountPercent > 0) {
        const discountedRateCents = Math.max(0, Math.round(baseRateCents * (100 - discountPercent) / 100));
        return `<span class="ss-cart-shipping-price-old">${ssMoney(baseRateCents, cfg)}</span><span class="ss-cart-shipping-discounted">${ssMoney(discountedRateCents, cfg)}</span>`;
      }
      return ssMoney(baseRateCents, cfg);
    }

    function ssSelectedShippingCountry(cfg) {
      const fallback = String(cfg?.shippingDefaultCountry || "NL").toUpperCase();
      const goals = cfg?.shippingGoalsByCountry || {};
      try {
        const stored = String(localStorage.getItem(SS_SHIPPING_COUNTRY_KEY) || "").toUpperCase();
        if (stored && Object.prototype.hasOwnProperty.call(goals, stored) && (ssShippingAlwaysFree(cfg, stored) || ssShippingGoalCents(cfg, stored) > 0)) return stored;
      } catch {}
      return fallback;
    }

    function ssSetSelectedShippingCountry(countryCode) {
      try {
        localStorage.setItem(SS_SHIPPING_COUNTRY_KEY, String(countryCode || "NL").toUpperCase());
      } catch {}
    }

    function ssShippingCountryName(countryCode) {
      const country = String(countryCode || "NL").toUpperCase();
      if (country === "BE") return "België";
      if (country === "DE") return "Duitsland";
      return "Nederland";
    }

    function ssShippingCountryPreposition(countryCode) {
      return String(countryCode || "NL").toUpperCase() === "NL" ? "in" : "naar";
    }

    function ssShippingTitleHtml(options) {
      const country = String(options?.country || "NL").toUpperCase();
      const countryName = ssShippingCountryName(country);
      const preposition = ssShippingCountryPreposition(country);

      if (ssShippingAlwaysFree(options?.cfg, country)) {
        return `Gratis standaardverzending ${preposition} ${countryName}. Geen minimum bestelbedrag.`;
      }
      if (options?.empty && country === "NL") {
        return "Gratis standaardverzending in Nederland.";
      }

      if (options?.free) {
        return `Je profiteert van gratis verzending ${preposition} ${countryName}.`;
      }

      const amount = ssMoney(Math.max(0, options?.diff || 0), options?.cfg);
      const extra = options?.showActionShippingNote ? " extra" : "";
      return `Besteed nog <span class="amount_till_free">${amount}</span>${extra} voor gratis verzending ${preposition} ${countryName}.`;
    }

    function ssUpdateShippingCountryButtons(selectedCountry) {
      document.querySelectorAll("[data-ss-shipping-country]").forEach((button) => {
        const isActive = String(button.dataset.ssShippingCountry || "").toUpperCase() === selectedCountry;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function initShippingCountrySelector() {
      document.querySelectorAll("[data-ss-shipping-country]").forEach((button) => {
        if (button.dataset.ssShippingCountryBound === "1") return;
        button.dataset.ssShippingCountryBound = "1";
        button.addEventListener("click", () => {
          const country = String(button.dataset.ssShippingCountry || "NL").toUpperCase();
          ssSetSelectedShippingCountry(country);
          applyTierPricingUI();
        });
      });
    }

    function applyTierPricingUI() {
      const cfg = ssParseJSON("ss-b2b-cart-tiers");
      if (!cfg) return;

      const tiersByProduct = cfg.tiersByProduct || {};
      const taxRate = cfg.taxRate || 21;

      // subregels (schaduwproducten) per config-id
      const subByCfg = new Map();
      // totaal per druktechniek-variant (voor staffels op techniek)
      const techQtyByVariant = new Map();

      document.querySelectorAll("[data-config-sub-input]").forEach((inp) => {
        const id = inp.dataset.configId;
        if (!id) return;

        const productId = inp.dataset.subProductId || "";
        const variantId = inp.dataset.subVariantId || "";
        const qty = parseInt(inp.value || "0", 10) || 0;

        subByCfg.set(id, {
          productId,
          variantId,
          unitOriginal: parseInt(inp.dataset.subUnitOriginal || "0", 10) || 0,
          unitFinal: parseInt(inp.dataset.subUnitFinal || "0", 10) || 0,
          lineFinal: parseInt(inp.dataset.subLineFinal || "0", 10) || 0,
          qty,
        });

        if (variantId && qty > 0) {
          techQtyByVariant.set(variantId, (techQtyByVariant.get(variantId) || 0) + qty);
        }
      });


// -----------------------------
// Aanpassen modal (vervang bundel: hoofd + schaduw)
// -----------------------------
(function initEditModal() {
  const modal = document.getElementById('ssEditModal');
  if (!modal) return;

  const elQty = modal.querySelector('#ssEditQty');
  const elColor = modal.querySelector('#ssEditColor');
  const elVariant = modal.querySelector('#ssEditVariant');
  const elTech = modal.querySelector('#ssEditTechnique');
  const elErr = modal.querySelector('#ssEditError');
  const elTitle = modal.querySelector('#ssEditModalTitle');
  const elMin = modal.querySelector('#ssEditMinMsg');
  const elMinHint = modal.querySelector('#ssEditMinHint');
  const btnSave = modal.querySelector('#ssEditSave');

  const productCache = new Map();
  let state = null;

  const parseJSON = (el) => {
    try { return JSON.parse(el?.textContent || 'null'); } catch { return null; }
  };

  const setError = (msg) => {
    if (!elErr) return;
    const text = String(msg || '').trim();
    if (!text) {
      elErr.hidden = true;
      elErr.textContent = '';
      return;
    }
    elErr.hidden = false;
    elErr.textContent = text;
  };

  const setMinHint = (content) => {
    if (!elMinHint) return;

    // String/number → plain text
    if (typeof content === 'string' || typeof content === 'number') {
      const t = String(content).trim();
      if (!t) {
        elMinHint.hidden = true;
        elMinHint.textContent = '';
        return;
      }
      elMinHint.textContent = t;
      elMinHint.hidden = false;
      return;
    }

    // Node / DocumentFragment → HTML inhoud (veilig opgebouwd via DOM)
    if (content && typeof content === 'object' && 'nodeType' in content) {
      elMinHint.textContent = '';
      elMinHint.appendChild(content);
      elMinHint.hidden = false;
      return;
    }

    // Fallback: verbergen
    elMinHint.hidden = true;
    elMinHint.textContent = '';
  };

  const setMinMsg = (msg) => {
    if (!elMin) return;
    elMin.hidden = !msg;
    elMin.textContent = msg || '';
  };

  const showFixedError = (allowed) => {
    if (!elErr) return;

    const fixed = Array.isArray(allowed)
      ? allowed
          .map((n) => int(n))
          .filter((n) => Number.isFinite(n) && n > 0)
      : [];

    if (!fixed.length) {
      setError('Kies een geldig aantal.');
      return;
    }

    elErr.hidden = false;
    elErr.textContent = '';

    const labelSpan = document.createElement('span');
    labelSpan.textContent = 'Kies een geldig aantal: ';
    elErr.appendChild(labelSpan);

    const wrap = document.createElement('span');
    wrap.className = 'ss-modal__qty-links';

    fixed.forEach((n, idx) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ss-modal__qty-link';
      btn.setAttribute('data-ss-set-qty', String(n));
      btn.textContent = String(n);
      wrap.appendChild(btn);
      if (idx < fixed.length - 1) {
        wrap.appendChild(document.createTextNode(', '));
      }
    });

    elErr.appendChild(wrap);
  };

  const setBusy = (busy) => {
    if (!btnSave) return;
    btnSave.disabled = !!busy;
    btnSave.classList.toggle('is-loading', !!busy);
  };

  const setRowVisible = (selector, visible) => {
    const row = modal.querySelector(selector);
    if (row) row.hidden = !visible;
  };

  const fillSelect = (select, options, selected) => {
    if (!select) return;
    select.innerHTML = '';
    for (const opt of options) {
      const o = document.createElement('option');
      o.value = String(opt.value);
      o.textContent = opt.label;
      if (opt.disabled) o.disabled = true;
      select.appendChild(o);
    }
    if (selected != null) select.value = String(selected);
  };

  const show = () => { modal.hidden = false; };
  const hide = () => {
    modal.hidden = true;
    state = null;
    setError('');
    setMinMsg('');
    setBusy(false);
  };

  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-ss-modal-close]')) hide();
  });

  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      hide();
      return;
    }

    if (e.key === 'Enter' && btnSave) {
      e.preventDefault();
      e.stopPropagation();
      btnSave.click();
    }
  });

  function randomToken() {
    if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    return 'ss_' + Math.random().toString(16).slice(2) + Date.now().toString(16);
  }

  async function getProduct(handle) {
    if (!handle) throw new Error('Geen product-handle');
    if (productCache.has(handle)) return productCache.get(handle);

    const r = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('Product niet gevonden');
    const j = await r.json();
    productCache.set(handle, j);
    return j;
  }

  function pickVariant(product, preferVariantId, preferOptions) {
    if (!product?.variants?.length) return null;

    // 1) voorkeur variant-id
    if (preferVariantId) {
      const v = product.variants.find(v => String(v.id) === String(preferVariantId));
      if (v && v.available) return v;
    }

    // 2) voorkeur opties (maat)
    if (preferOptions) {
      const v = product.variants.find(v =>
        (!preferOptions.option1 || v.option1 === preferOptions.option1) &&
        (!preferOptions.option2 || v.option2 === preferOptions.option2) &&
        (!preferOptions.option3 || v.option3 === preferOptions.option3) &&
        v.available
      );
      if (v) return v;
    }

    // 3) first available
    return product.variants.find(v => v.available) || product.variants[0];
  }

  function buildTechniqueSelect(list, currentSubVariantId) {
    const hasTech = Array.isArray(list) && list.length > 0;

    // Altijd resetten (tegen "sticky" values van vorig item)
    const opts = [{ value: 'none', label: 'Onbedrukt' }]
      .concat(hasTech ? list.map(t => ({ value: t.id, label: t.title })) : []);

    fillSelect(elTech, opts, currentSubVariantId ? String(currentSubVariantId) : 'none');
    setRowVisible('[data-ss-edit-tech-row]', hasTech);
  }

  function isActionPrintLockedMode(mode) {
    const m = String(mode || '').trim().toLowerCase();
    return m.includes('alleen bestelbaar met vaste opdruk') || m.includes('vaste opdruk + eigen rugbedrukking');
  }

  function getTechniqueLabelById(list, techId) {
    const id = String(techId || '').trim();
    if (!id || id === 'none') return 'Onbedrukt';

    const tech = (Array.isArray(list) ? list : []).find((item) => {
      return String(item?.id || '') === id;
    });

    return String(tech?.title || '').trim() || 'Onbedrukt';
  }

  function buildColorSelect(colors, currentHandle) {
    const list = Array.isArray(colors) && colors.length ? colors : [{ handle: currentHandle, title: currentHandle }];
    const hasColors = list.length > 1;

    // Altijd resetten (tegen "sticky" values van vorig item)
    fillSelect(elColor, list.map(c => ({
      value: c.handle,
      label: c.title || c.handle
    })), currentHandle);

    setRowVisible('[data-ss-edit-color-row]', hasColors);
  }

  async function buildVariantSelect(handle, preferredVariantId) {
    const product = await getProduct(handle);
    const selected = pickVariant(product, preferredVariantId, state?.variantOptions);

    state.variantOptions = selected
      ? { option1: selected.option1, option2: selected.option2, option3: selected.option3 }
      : null;

    const opts = product.variants.map(v => ({
      value: v.id,
      label:
        (v.public_title && v.public_title !== 'Default Title')
          ? v.public_title
          : (v.title || 'Variant'),
      disabled: !v.available
    }));

    const showVariant = product.variants.length > 1;
    setRowVisible('[data-ss-edit-variant-row]', showVariant);

    if (showVariant) {
      fillSelect(elVariant, opts, selected?.id);
    } else {
      // 1 variant: rij verbergen, maar wél 1 option laten staan zodat elVariant.value klopt
      const vid = selected?.id || (product.variants[0]?.id || '');
      fillSelect(elVariant, [{ value: vid, label: 'Default' }], vid);
    }

    state.variantId = selected?.id || (product.variants[0]?.id || state.variantId);
    state.productId = product.id || state.productId || 0;
  }

  async function cartAddItems(items) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: window.SS_B2B_CART.nestItems(items) })
    });

    if (!r.ok) {
      let msg = 'Toevoegen mislukt.';
      try {
        const j = await r.json();
        msg = j?.description || j?.message || msg;
      } catch {}
      throw new Error(msg);
    }
    return r.json();
  }

  function hasUploadedBedrukkingProps(props) {
    if (!props || typeof props !== 'object') return false;
    return Boolean(
      props._uploaded_bedrukking_ids ||
      props._uploaded_bedrukking_label
    );
  }

  function stripUploadedBedrukkingProps(props) {
    const next = Object.assign({}, props || {});
    delete next._uploaded_bedrukking_ids;
    delete next._uploaded_bedrukking_label;
    return next;
  }

  function stripSsB2bBundleProps(props) {
    const next = Object.assign({}, props || {});
    SS_B2B_BUNDLE_PROP_KEYS.forEach((key) => {
      delete next[key];
    });
    return next;
  }

	  function ssCompactId(value) {
	    return String(value ?? '').trim();
	  }

	  function cartLineProps(line) {
	    return line?.properties && typeof line.properties === 'object' ? line.properties : {};
	  }

	  function cartLineVariantId(line) {
	    return int(line?.variant_id || line?.id);
	  }

	  function cartLineRole(line) {
	    return ssCompactId(cartLineProps(line)._ss_b2b_role);
	  }

	  function cartLineConfigMain(line) {
	    const props = cartLineProps(line);
	    return ssCompactId(props._config_main || props.config_main);
	  }

	  function cartLineConfigSub(line) {
	    const props = cartLineProps(line);
	    return ssCompactId(props._config_sub || props.config_sub);
	  }

	  function cartLineBundleId(line) {
	    const props = cartLineProps(line);
	    return ssCompactId(
	      props._ss_b2b_bundle_id ||
	      props._config_main ||
	      props.config_main ||
	      props._config_sub ||
	      props.config_sub
	    );
	  }

	  function resolveSsB2bBundleLines(cart, options = {}) {
	    const items = Array.isArray(cart?.items) ? cart.items : [];
	    const mainKey = ssCompactId(options.mainKey);
	    const cfgId = ssCompactId(options.cfgId);
	    const variantId = int(options.variantId);
	    const subVariantId = int(options.subVariantId);
	    const productHandle = ssCompactId(options.productHandle);
	    const qty = int(options.qty);

	    const printLinesForBundle = (bundleId) => {
	      const id = ssCompactId(bundleId);
	      return items.filter((line) => {
	        const role = cartLineRole(line);
	        const cfgSub = cartLineConfigSub(line);
	        const lineBundle = cartLineBundleId(line);
	        if (role !== 'print' && !cfgSub) return false;
	        if (!id) return role === 'print' || Boolean(cfgSub);
	        return lineBundle === id || cfgSub === id;
	      });
	    };

	    let mainLine = mainKey ? items.find((line) => line.key === mainKey) : null;
	    if (mainLine && (cartLineRole(mainLine) === 'print' || cartLineConfigSub(mainLine))) {
	      mainLine = null;
	    }

	    let bundleId = cfgId || cartLineBundleId(mainLine) || cartLineConfigMain(mainLine);
	    let printLines = printLinesForBundle(bundleId);

	    if (!mainLine || (variantId && cartLineVariantId(mainLine) !== variantId)) {
	      const candidates = items
	        .filter((line) => {
	          if (cartLineRole(line) === 'print' || cartLineConfigSub(line)) return false;
	          if (variantId && cartLineVariantId(line) !== variantId) return false;
	          if (productHandle && line.handle && ssCompactId(line.handle) !== productHandle) return false;
	          return true;
	        })
	        .map((line) => {
	          const candidateBundleId = cfgId || cartLineBundleId(line) || cartLineConfigMain(line);
	          const candidatePrints = printLinesForBundle(candidateBundleId);
	          let score = 0;
	          if (mainKey && line.key === mainKey) score += 100;
	          if (cfgId && candidateBundleId === cfgId) score += 80;
	          if (subVariantId && candidatePrints.some((printLine) => cartLineVariantId(printLine) === subVariantId)) score += 30;
	          if (qty && int(line.quantity) === qty) score += 10;
	          if (candidatePrints.length) score += 5;
	          return { line, bundleId: candidateBundleId, printLines: candidatePrints, score };
	        })
	        .sort((a, b) => b.score - a.score);

	      if (candidates.length) {
	        mainLine = candidates[0].line;
	        bundleId = candidates[0].bundleId;
	        printLines = candidates[0].printLines;
	      }
	    }

	    if (!printLines.length) {
	      printLines = printLinesForBundle(bundleId);
	    }

	    return {
	      mainLine,
	      printLines,
	      bundleId: bundleId || cartLineBundleId(mainLine) || cartLineConfigMain(mainLine),
	    };
	  }

	  function ssImageUrl(value) {
	    const url = ssCompactId(value);
    if (!url) return '';
    if (url.startsWith('//')) return `https:${url}`;
    return url;
  }

  function ssBundleProps(token, role, extra = {}) {
    const bundleId = ssCompactId(token);
    if (!bundleId) return {};

    const props = {
      _ss_b2b_bundle_id: bundleId,
      _ss_b2b_print_group_id: `${bundleId}:print:1`,
      _ss_b2b_role: role,
    };

    Object.entries(extra || {}).forEach(([key, value]) => {
      const clean = ssCompactId(value);
      if (clean) props[key] = clean;
    });

    return props;
  }

  function productImageUrl(product, variantId) {
    const variant = (product?.variants || []).find((v) => String(v.id) === String(variantId));
    return ssImageUrl(
      variant?.featured_image?.src ||
      variant?.featured_image ||
      product?.featured_image ||
      product?.images?.[0] ||
      ''
    );
  }

  const minForHandle = (handle) => {
    const h = String(handle || '');
    const entry = (state?.colors || []).find(c => String(c.handle) === h);
    const m = int(entry?.min);
    return Math.max(m || int(state?.min) || 0, int(state?.configuratorMinimum));
  };

  const wouldViolateMinInModal = (handle, newQty) => {
    const min = minForHandle(handle);
    if (!min) return false;

    const q = int(newQty);
    const currentTotal = int(state?.currentTotal);
    const currentLine = int(state?.currentLine);
    const newTotal = currentTotal - currentLine + q;

    return newTotal > 0 && newTotal < min;
  };

  const updateMinUi = () => {
    const qty = int(elQty?.value);
    // eventuele eerdere foutbalk wissen; inline meldingen tonen we hier niet meer
    setError('');

    // In jouw state heet dit "min" (oude versies hadden soms "minimum")
    const min = int(state?.min ?? state?.minimum ?? 0);
    const allowed = Array.isArray(state?.qtyOptions) ? state.qtyOptions : [];

// Zwarte hint (klikbare mogelijke aantallen)
    const hasMin = !!min;
    const hasAllowed = allowed.length > 0;

    if (!hasMin && !hasAllowed) {
      setMinHint('');
    } else {
      const frag = document.createDocumentFragment();

      if (hasMin) {
        frag.appendChild(document.createTextNode(`Minimale afname: ${min} stuks`));
      }

      if (hasAllowed) {
        // i.p.v. " · " → nieuwe regel
        if (hasMin) frag.appendChild(document.createElement('br'));
        frag.appendChild(document.createTextNode('Mogelijke aantallen: '));

        const wrap = document.createElement('span');
        wrap.className = 'ss-modal__qty-links';

        allowed.forEach((n, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ss-modal__qty-link';
          if (n === qty) b.classList.add('is-active');
          b.setAttribute('data-ss-set-qty', String(n));
          b.textContent = String(n);

          wrap.appendChild(b);
          if (i < allowed.length - 1) wrap.appendChild(document.createTextNode(', '));
        });

        frag.appendChild(wrap);
      }

      setMinHint(frag);
    }

    setMinMsg('');
  };

  elQty?.addEventListener('input', updateMinUi);

  // Nieuw: klik op een mogelijk aantal → zet Aantal direct
  elMinHint?.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ss-set-qty]');
    if (!btn) return;

    const v = int(btn.getAttribute('data-ss-set-qty'));
    if (!v) return;

    if (elQty) {
      elQty.value = String(v);
      elQty.dispatchEvent(new Event('input', { bubbles: true }));
      elQty.focus();
    }
    setError('');
  });

  elErr?.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ss-set-qty]');
    if (!btn) return;

    const v = int(btn.getAttribute('data-ss-set-qty'));
    if (!v) return;

    if (elQty) {
      elQty.value = String(v);
      elQty.dispatchEvent(new Event('input', { bubbles: true }));
      elQty.focus();
    }
    setError('');
  });

  // Open modal
  form.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-ss-edit');
    if (!btn) return;

    e.preventDefault();

    const ci = btn.closest('cart-item');
    if (!ci) return;

    if (btn.dataset.ssConfigurator === '19mw1016' && btn.dataset.configId && btn.dataset.productHandle) {
      const editUrl = new URL('/products/' + encodeURIComponent(btn.dataset.productHandle), location.origin);
      editUrl.searchParams.set('view', '19MW1016_configurator');
      editUrl.searchParams.set('ss_cart_edit', btn.dataset.configId);
      location.assign(editUrl.toString());
      return;
    }

    if (elTitle) {
      const rawTitle = ci.querySelector('.ss-cart-item__title');
      const titleText = (rawTitle?.textContent || '').trim();
      elTitle.textContent = titleText ? `Aanpassen: ${titleText}` : 'Aanpassen';
    }

    setBusy(false);
    setError('');
    setMinMsg('');

    const cfgId = btn.dataset.configId || '';
    const mainKey = btn.dataset.itemKey || '';
    const productHandle = btn.dataset.productHandle || '';
    const variantId = int(btn.dataset.variantId);
    const qty = int(btn.dataset.qty);
    const cartLine = int(btn.dataset.cartLine || ci.dataset.cartLine);
    const removeUrl = btn.dataset.removeUrl || ci.dataset.removeUrl || '';

    // sub keys (alle schaduwregels met dezelfde config-id)
    const subKeys = [];
    if (cfgId) {
      document
        .querySelectorAll(`[data-config-sub-input][data-config-id="${CSS.escape(cfgId)}"]`)
        .forEach(inp => inp.dataset.itemKey && subKeys.push(inp.dataset.itemKey));
    }

    const techList = parseJSON(ci.querySelector('[data-ss-edit-techniques]')) || [];
    const colors = parseJSON(ci.querySelector('[data-ss-edit-colors]')) || [];
    const bedrukkingModus = ci.dataset.ssBedrukkingModus || '';
    const printLocked = isActionPrintLockedMode(bedrukkingModus);

    const cq = ci.querySelector('cart-quantity');

    state = {
      mainKey,
      subKeys,
      cfgId,
      productHandle,
      variantId,
      cartLine,
      removeUrl,
      subVariantId: int(btn.dataset.subVariantId),
      techniques: techList,
      colors,
	      printLocked,
	      variantOptions: null,
	      currentTotal: int(cq?.dataset.currentTotal) || qty,
	      currentLine: int(cq?.dataset.currentQuantity) || qty,
	      min: int(cq?.dataset.minimumQuantity),
          configuratorMinimum: int(cq?.dataset.configuratorMinimum),

      // Vaste aantallen (optioneel)
      qtyOptions: getFixedQtyOptionsFromCQ(cq),

      productId: 0,
    };

    try {
      if (elQty) elQty.value = String(qty || 1);

      buildColorSelect(colors, productHandle);
      buildTechniqueSelect(techList, state.subVariantId);
      if (state.printLocked) {
        setRowVisible('[data-ss-edit-tech-row]', false);
      }

      await buildVariantSelect(productHandle, variantId);

      if (elColor) {
        elColor.onchange = async () => {
          setError('');
          setMinMsg('');
          try {
            await buildVariantSelect(elColor.value, null);
            updateMinUi();
          } catch (err) {
            setError('Kleur laden lukt niet.');
          }
        };
      }

      if (elVariant) {
        elVariant.onchange = async () => {
          try {
            const p = await getProduct(elColor?.value || productHandle);
            const v = p.variants.find(v => String(v.id) === String(elVariant.value));
            if (v) state.variantOptions = { option1: v.option1, option2: v.option2, option3: v.option3 };
          } catch {}
        };
      }

      elTech && (elTech.onchange = () => { setError(''); });

      updateMinUi();
      show();
    } catch (err) {
      console.error(err);
      setError('Aanpassen kon niet geladen worden.');
      show();
    }
  });

  // Opslaan
  btnSave?.addEventListener('click', async () => {
    if (!state) return;

    setBusy(true);
    setError('');

    const qty = int(elQty?.value);
    if (qty <= 0) {
      setError('Aantal moet minimaal 1 zijn.');
      setBusy(false);
      return;
    }

    const handle = String(elColor?.value || state.productHandle || '');

    const fixedAllowed = Array.isArray(state?.qtyOptions) ? state.qtyOptions : [];
    if (fixedAllowed.length && !fixedAllowed.includes(qty)) {
      showFixedError(fixedAllowed);
      setBusy(false);
      elQty?.focus();
      return;
    }


    // Min check (met duidelijk getal)
    const min = minForHandle(handle);
    if (min && wouldViolateMinInModal(handle, qty)) {
      showCartMinModal(
        `${min} stuks is de minimale afname. Pas de aantallen aan tot minimaal ${min} stuks in totaal.`
      );
      setMinMsg('');
      setBusy(false);
      elQty?.focus();
      return;
    }

    try {
	      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
	      const resolvedBundle = resolveSsB2bBundleLines(cart, {
	        mainKey: state.mainKey,
	        cfgId: state.cfgId,
	        productHandle: state.productHandle,
	        variantId: state.variantId,
	        subVariantId: state.subVariantId,
	        qty,
	      });
	      const oldMainLine = resolvedBundle.mainLine;
	      const fallbackCartLine = int(state.cartLine);
	      const fallbackVisibleLine = fallbackCartLine
	        ? (Array.isArray(cart.items) ? cart.items[fallbackCartLine - 1] : null)
	        : null;
	      const fallbackVisibleKey = fallbackVisibleLine?.key || '';
	      if (!oldMainLine && !fallbackCartLine && !fallbackVisibleKey) {
	        throw new Error('Item niet gevonden in winkelwagen.');
	      }
	      const oldMainKey = oldMainLine?.key || state.mainKey;

	      let oldSubLines = (state.subKeys || [])
	        .map(k => cart.items.find(i => i.key === k))
	        .filter(Boolean);
	      if (!oldSubLines.length) {
	        oldSubLines = resolvedBundle.printLines;
	      }
	      const oldBundleId = resolvedBundle.bundleId || state.cfgId;

      // Resolve hoofd-variant bij gekozen kleur/product (extra safety)
      const product = await getProduct(handle);
      const preferredVariantId = int(elVariant?.value) || int(state.variantId);
      const picked = pickVariant(product, preferredVariantId, state.variantOptions);
      const newMainVariantId = int(picked?.id);
      if (!newMainVariantId) throw new Error('Kies een geldige variant.');

      const currentHandle = String(oldMainLine?.handle || state.productHandle || '');
      const currentMainVariantId = int(oldMainLine?.variant_id || oldMainLine?.id || state.variantId);
      const currentTechVariantId = oldSubLines.length
        ? int(oldSubLines[0].variant_id || oldSubLines[0].id)
        : int(state.subVariantId);

      // Druktechniek (alleen als dit product drukopties heeft)
      let newTechVariantId = 0;
      let techLabel = 'Onbedrukt';
      if (state.printLocked) {
        newTechVariantId = currentTechVariantId;
        techLabel = String(oldSubLines[0]?.properties?._druktechniek || getTechniqueLabelById(state.techniques, currentTechVariantId) || 'Vaste opdruk').trim();
      } else if (Array.isArray(state.techniques) && state.techniques.length) {
        const techVal = String(elTech?.value || 'none');
        newTechVariantId = techVal !== 'none' ? int(techVal) : 0;
        techLabel = getTechniqueLabelById(state.techniques, techVal);
      }

      const mustStripUploads = !newTechVariantId && hasUploadedBedrukkingProps(oldMainLine?.properties || {});

      const onlyQty =
        handle === currentHandle &&
        newMainVariantId === currentMainVariantId &&
        newTechVariantId === currentTechVariantId &&
        !mustStripUploads;

	      // 1) Alleen quantity? → in-place update (geen remove/add, voorkomt max-stock issues bij verlagen)
	      if (onlyQty) {
	        if (oldMainLine) {
	          const updates = { [oldMainKey]: qty };
	          oldSubLines.forEach(l => { updates[l.key] = qty; });
	          await apply(updates);
	        } else {
	          await changeCartLine(fallbackCartLine, qty);
	        }
	        ssCartStoreFlash({ token: oldBundleId || state.cfgId, mainKey: oldMainKey });
	        location.reload();
	        return;
	      }

      // 2) Anders: vervang bundel (remove → add), met rollback bij fout
      const token = randomToken();

      let newMainProps = Object.assign({}, oldMainLine?.properties || {});
      delete newMainProps._config_sub;
      delete newMainProps.config_sub;
      delete newMainProps._config_main;
      delete newMainProps.config_main;
      newMainProps = stripSsB2bBundleProps(newMainProps);
      if (!newTechVariantId) {
        newMainProps = stripUploadedBedrukkingProps(newMainProps);
      }
      newMainProps._config_main = token;
      if (newTechVariantId) {
        Object.assign(newMainProps, ssBundleProps(token, 'main', {
          _ss_b2b_parent_product_id: product.id || oldMainLine?.product_id || '',
          _ss_b2b_parent_variant_id: newMainVariantId,
          _ss_b2b_image_url: productImageUrl(product, newMainVariantId),
        }));
      }

      const itemsToAdd = [{ id: newMainVariantId, quantity: qty, properties: newMainProps }];

      if (newTechVariantId) {
        let newShadowProps = {};
        if (oldSubLines.length) newShadowProps = Object.assign({}, oldSubLines[0].properties || {});

        delete newShadowProps._config_main;
        delete newShadowProps.config_main;
        delete newShadowProps._config_sub;
        delete newShadowProps.config_sub;
        delete newShadowProps.tech_for;
        newShadowProps = stripSsB2bBundleProps(newShadowProps);

        newShadowProps._config_sub = token;
        newShadowProps._druktechniek = techLabel;
        Object.assign(newShadowProps, ssBundleProps(token, 'print', {
          _ss_b2b_parent_product_id: product.id || oldMainLine?.product_id || '',
          _ss_b2b_parent_variant_id: newMainVariantId,
          _ss_b2b_shadow_variant_id: newTechVariantId,
        }));

        // Interne koppeling verbergen in checkout via underscore-property.
        if (!newShadowProps._tech_for) {
          newShadowProps._tech_for = String(product.id || oldMainLine?.product_id || '');
        }

        itemsToAdd.push({ id: newTechVariantId, quantity: qty, properties: newShadowProps });
      }

	      // Raw cart-regels kunnen we direct vervangen. Bij een getransformeerde
	      // zichtbare bundelregel bestaat alleen het Shopify line-nummer/key nog.
	      if (oldMainLine) {
	        const updatesZero = { [oldMainKey]: 0 };
	        oldSubLines.forEach(l => { updatesZero[l.key] = 0; });
	        await apply(updatesZero);
	      } else if (fallbackVisibleKey) {
	        await apply({ [fallbackVisibleKey]: 0 });
	      } else {
	        await changeCartLine(fallbackCartLine, 0);
	      }

      try {
        await cartAddItems(itemsToAdd);
      } catch (addErr) {
        // rollback: voeg oude regels terug
        if (oldMainLine) {
          try {
            const rollback = [];

            rollback.push({
              id: int(oldMainLine.variant_id || oldMainLine.id),
              quantity: int(oldMainLine.quantity),
              properties: Object.assign({}, oldMainLine.properties || {})
            });

            oldSubLines.forEach(l => {
              rollback.push({
                id: int(l.variant_id || l.id),
                quantity: int(l.quantity),
                properties: Object.assign({}, l.properties || {})
              });
            });

            await cartAddItems(rollback);
          } catch (rbErr) {
            console.error('Rollback mislukt', rbErr);
          }
        }

        throw addErr;
      }

      // Na wijziging in kleur/variant/bedrukking ook visuele flash tonen
	      ssCartStoreFlash({ token, mainKey: oldMainKey });
      location.reload();
    } catch (err) {
      console.error(err);
      setError(err.message || 'Opslaan mislukt.');
      setBusy(false);
    }
  });
})();;




      let subtotalEx = 0;
      let freeShippingActionTotal = 0;
      let hasFreeShippingActionProduct = false;
      let hasInternationalExcludedActionProduct = false;
      let hasPaidShippingItem = false;

      document.querySelectorAll("cart-item.ss-cart-item").forEach((ci) => {
        const qty = parseInt(ci.dataset.ssQty || "0", 10) || 0;
        const isTransformBundle = ci.classList.contains('ss-cart-item--transform-bundle');

        // qty totaal van dit product (voor staffels op hoofdproduct)
        const cq = ci.querySelector("cart-quantity");
        const productTotalQty = parseInt(cq?.dataset?.currentTotal || String(qty), 10) || qty;

        const productId = String(ci.dataset.productId || "");
        const bedrukkingModus = (ci.dataset.ssBedrukkingModus || '').trim().toLowerCase();
        const isPrintIncluded = bedrukkingModus.includes('bedrukking verplicht inbegrepen');
        const isUnprintedOnly = bedrukkingModus === 'alleen onbedrukt';
        const isFixedPrintOnly = bedrukkingModus.includes('alleen bestelbaar met vaste opdruk');
        const isFixedPrintWithCustomBack = bedrukkingModus.includes('vaste opdruk + eigen rugbedrukking');
        const isFreeShippingProduct = ci.dataset.ssFreeShippingProduct === 'true' || ci.dataset.ssFreeShippingProduct === '1';
        const isActionFreeShippingProduct = isFreeShippingProduct && (isFixedPrintOnly || isFixedPrintWithCustomBack);

        const mainUnitFinal = parseInt(ci.dataset.ssMainUnitFinal || ci.dataset.ssMainUnit || "0", 10) || 0;
        const mainUnitOriginal = parseInt(ci.dataset.ssMainUnitOriginal || String(mainUnitFinal), 10) || mainUnitFinal;
        const mainLineFinal = parseInt(ci.dataset.ssMainLineFinal || ci.dataset.ssMainLine || "0", 10) || (mainUnitFinal * qty);

        const mainAlreadyDiscounted = !isTransformBundle && mainUnitOriginal && mainUnitFinal && mainUnitFinal < mainUnitOriginal;

        // === Hoofdproduct staffel (Type 3: directe tiers op hoofdproduct) ===
        // Bij vaste borst/mouw-opdruk + eigen rugopdruk staffelt alleen de gekoppelde
        // rugopdrukregel. Hoofdproducttiers negeren we om gelijk te blijven aan checkout.
        const tiersMain = isFixedPrintWithCustomBack ? [] : (tiersByProduct[productId] || []);

        let mainUnitEx = mainUnitFinal;
        let mainLineEx = mainLineFinal;

        if (!mainAlreadyDiscounted) {
          mainUnitEx = ssTierUnitCents(mainUnitOriginal, productTotalQty, tiersMain);
          mainLineEx = mainUnitEx * qty;
        }

        // Update “Zonder bedrukking” box (ook voor Type 3)
        const noBox = ci.querySelector(".ss-pricebox--no-print");
        if (noBox) {
          const rows = noBox.querySelectorAll(".ss-pricebox__row");

          // Per stuk
          if (rows[0]) {
            const exEl = rows[0].querySelector(".ss-ex");
            const incEl = rows[0].querySelector(".ss-inc");
            if (exEl) exEl.textContent = ssMoney(mainUnitEx, cfg);
            if (incEl) incEl.innerHTML = `${ssMoney(ssIncFromEx(mainUnitEx, taxRate), cfg)} <span class="ss-inc__label">incl.</span>`;
          }

          // Totaal
          if (rows[1]) {
            const exEl = rows[1].querySelector(".ss-ex");
            const incEl = rows[1].querySelector(".ss-inc");
            if (exEl) exEl.textContent = ssMoney(mainLineEx, cfg);
            if (incEl) incEl.innerHTML = `${ssMoney(ssIncFromEx(mainLineEx, taxRate), cfg)} <span class="ss-inc__label">incl.</span>`;
          }
        }

        const cfgId = ci.dataset.configId || "";
        const sub = cfgId ? subByCfg.get(cfgId) : null;


        // Producten met een expliciete bedrukking-modus.
        const noBoxHead = ci.querySelector('.ss-pricebox--no-print');
        if (noBoxHead) {
          const headTitle = noBoxHead.querySelector('.ss-pricebox__head-title');
          const noteEl = noBoxHead.querySelector('[data-ss-printonly-note]');

          if (isPrintIncluded) {
            if (headTitle) headTitle.textContent = 'Met bedrukking (incl. opdruk)';
            if (noteEl) {
              noteEl.textContent = 'Alleen bestelbaar met bedrukking';
              noteEl.hidden = false;
            }
          } else if (isFixedPrintWithCustomBack) {
            if (headTitle) headTitle.textContent = 'Totaalprijs: product incl. vaste opdruk';
            if (noteEl) {
              noteEl.textContent = 'Inclusief vaste opdruk en gekozen rugbedrukking';
              noteEl.hidden = false;
            }
          } else if (isFixedPrintOnly) {
            if (headTitle) headTitle.textContent = 'Totaalprijs: product incl. vaste opdruk';
            if (noteEl) {
              noteEl.textContent = 'Alleen bestelbaar met vaste opdruk';
              noteEl.hidden = false;
            }
          } else if (isUnprintedOnly) {
            if (headTitle) headTitle.textContent = 'Stukprijs (onbedrukt)';
            if (noteEl) {
              noteEl.textContent = 'Alleen bestelbaar zonder bedrukking';
              noteEl.hidden = false;
            }
          } else {
            if (headTitle) headTitle.textContent = 'Stukprijs (onbedrukt)';
            if (noteEl) noteEl.hidden = true;
          }
        }

        if (isTransformBundle) {
          const transformUnitEx = parseInt(ci.dataset.ssTransformUnit || "0", 10) || 0;
          const transformLineEx =
            parseInt(ci.dataset.ssTransformLine || "0", 10) || (transformUnitEx * qty);
          const lineEx = transformLineEx || mainLineEx;
          const unitEx = transformUnitEx || (qty ? Math.round(lineEx / qty) : 0);

          const withBox = ci.querySelector(".ss-pricebox--with-print");
          if (withBox) {
            const rows = withBox.querySelectorAll(".ss-pricebox__row");

            if (rows[0]) {
              const exEl = rows[0].querySelector(".ss-ex");
              const incEl = rows[0].querySelector(".ss-inc");
              if (exEl) exEl.textContent = ssMoney(unitEx, cfg);
              if (incEl) incEl.innerHTML = `${ssMoney(ssIncFromEx(unitEx, taxRate), cfg)} <span class="ss-inc__label">incl.</span>`;
            }

            if (rows[1]) {
              const exEl = rows[1].querySelector(".ss-ex");
              const incEl = rows[1].querySelector(".ss-inc");
              if (exEl) exEl.textContent = ssMoney(lineEx, cfg);
              if (incEl) incEl.innerHTML = `${ssMoney(ssIncFromEx(lineEx, taxRate), cfg)} <span class="ss-inc__label">incl.</span>`;
            }
          }

          const offerPayload = ci.querySelector('[data-ss-cart-offer-item]');
          if (offerPayload) {
            try {
              const payload = JSON.parse(offerPayload.textContent || '{}');
              payload.qty = qty;
              payload.unitExCents = unitEx;
              payload.lineExCents = lineEx;
              if (!payload.size && ci.dataset.ssSizeLabel) payload.size = ci.dataset.ssSizeLabel;
              offerPayload.textContent = JSON.stringify(payload);
            } catch {}
          }

          if (cfgId) subByCfg.delete(cfgId);

          if (isFreeShippingProduct) {
            hasFreeShippingActionProduct = true;
            freeShippingActionTotal += lineEx;
            if (isActionFreeShippingProduct) hasInternationalExcludedActionProduct = true;
          } else {
            hasPaidShippingItem = true;
          }

          subtotalEx += lineEx;
          return;
        }

        // basis: zonder bedrukking lijnprijs (evt. met staffel op hoofdproduct)
        let lineEx = mainLineEx;

        if (sub && qty > 0) {
          const alreadyDiscounted = !isTransformBundle && sub.unitOriginal && sub.unitFinal && sub.unitFinal < sub.unitOriginal;

          let subUnit = isTransformBundle
            ? (sub.unitOriginal || sub.unitFinal || 0)
            : (sub.unitFinal || sub.unitOriginal || 0);

          if (!alreadyDiscounted) {
            const tiers = tiersByProduct[sub.productId] || [];
            // Staffels op druktechniek: alleen aantallen met dezelfde techniek-variant laten meetellen
            const techTotal = techQtyByVariant.get(sub.variantId || "") || sub.qty || qty;
            subUnit = ssTierUnitCents((sub.unitOriginal || sub.unitFinal || 0), techTotal, tiers);
          }

          const withUnitEx = mainUnitEx + subUnit;
          const withLineEx = withUnitEx * qty;

          if (isTransformBundle) {
            const offerPayload = ci.querySelector('[data-ss-cart-offer-item]');
            if (offerPayload) {
              try {
                const payload = JSON.parse(offerPayload.textContent || '{}');
                payload.qty = qty;
                payload.unitExCents = withUnitEx;
                payload.lineExCents = withLineEx;
                if (!payload.size && ci.dataset.ssSizeLabel) payload.size = ci.dataset.ssSizeLabel;
                offerPayload.textContent = JSON.stringify(payload);
              } catch {}
            }
          }

          // Update “Met bedrukking” box
          const withBox = ci.querySelector(".ss-pricebox--with-print");
          if (withBox) {
            const rows = withBox.querySelectorAll(".ss-pricebox__row");

            // Per stuk
            if (rows[0]) {
              const exEl = rows[0].querySelector(".ss-ex");
              const incEl = rows[0].querySelector(".ss-inc");
              if (exEl) exEl.textContent = ssMoney(withUnitEx, cfg);
              if (incEl) incEl.innerHTML = `${ssMoney(ssIncFromEx(withUnitEx, taxRate), cfg)} <span class="ss-inc__label">incl.</span>`;
            }

            // Totaal
            if (rows[1]) {
              const exEl = rows[1].querySelector(".ss-ex");
              const incEl = rows[1].querySelector(".ss-inc");
              if (exEl) exEl.textContent = ssMoney(withLineEx, cfg);
              if (incEl) incEl.innerHTML = `${ssMoney(ssIncFromEx(withLineEx, taxRate), cfg)} <span class="ss-inc__label">incl.</span>`;
            }
          }

          lineEx = withLineEx;
          subByCfg.delete(cfgId); // mark “gebruikt”
        }

        if (isFreeShippingProduct) {
          hasFreeShippingActionProduct = true;
          freeShippingActionTotal += lineEx;
          if (isActionFreeShippingProduct) hasInternationalExcludedActionProduct = true;
        } else {
          hasPaidShippingItem = true;
        }

        subtotalEx += lineEx;
      });

      // eventuele losse subregels die niet gekoppeld waren (failsafe)
      subByCfg.forEach((sub) => {
        if (sub.lineFinal) subtotalEx += sub.lineFinal;
      });

      const selectedShippingCountry = ssSelectedShippingCountry(cfg);
      const goal = ssShippingGoalCents(cfg, selectedShippingCountry);
      const baseShippingRate = ssShippingBaseRateCents(cfg, selectedShippingCountry);
      const freeShippingProductDiscountPercent = ssFreeShippingProductDiscountPercent(cfg, selectedShippingCountry);
      const isNetherlandsShipping = selectedShippingCountry === "NL";
      const isEmptyCart = !document.querySelector("cart-item.ss-cart-item");
      const alwaysFreeShipping = ssShippingAlwaysFree(cfg, selectedShippingCountry);
      const isEmptyFreeShippingCart = isEmptyCart && (alwaysFreeShipping || isNetherlandsShipping);
      let shippingFree = alwaysFreeShipping;
      let shippingEligibleSubtotal = subtotalEx;
      let showActionShippingNote = false;
      let showPartialProductShippingNote = false;
      let showInternationalActionNote = false;
      const hasOnlyFreeShippingActionProducts = hasFreeShippingActionProduct && !hasPaidShippingItem;

      ssUpdateShippingCountryButtons(selectedShippingCountry);

      if (!alwaysFreeShipping && goal > 0) {
        shippingEligibleSubtotal = subtotalEx;
        shippingFree = subtotalEx > 0 && ((isNetherlandsShipping && hasOnlyFreeShippingActionProducts) || shippingEligibleSubtotal >= goal);
        showActionShippingNote = isNetherlandsShipping && hasFreeShippingActionProduct && hasPaidShippingItem && !shippingFree;
      }

      document.querySelectorAll(".ss-cart-item__shipping-note").forEach((note) => {
        const noteText = ssFreeShippingProductNoteText(
          selectedShippingCountry,
          freeShippingProductDiscountPercent,
          shippingFree
        );
        const label = note.querySelector("span");
        if (label && noteText) label.textContent = noteText;
        note.classList.toggle("is-hidden", !noteText);
      });

      const freeShippingProductDiscountActive =
        subtotalEx > 0 &&
        !shippingFree &&
        hasFreeShippingActionProduct &&
        hasOnlyFreeShippingActionProducts &&
        freeShippingProductDiscountPercent > 0;
      showPartialProductShippingNote =
        !isNetherlandsShipping &&
        hasFreeShippingActionProduct &&
        hasPaidShippingItem &&
        !shippingFree &&
        freeShippingProductDiscountPercent > 0;
      const shippingDiscountPercent = shippingFree ? 100 : (freeShippingProductDiscountActive ? freeShippingProductDiscountPercent : 0);
      const shippingDiscountAmount = baseShippingRate > 0 && shippingDiscountPercent > 0
        ? Math.round(baseShippingRate * shippingDiscountPercent / 100)
        : 0;
      const hasShippingSaving = subtotalEx > 0 && shippingDiscountAmount > 0;
      showInternationalActionNote =
        !isNetherlandsShipping &&
        hasInternationalExcludedActionProduct &&
        !shippingFree &&
        !freeShippingProductDiscountActive &&
        !showPartialProductShippingNote;

      const shippingCostEx = subtotalEx > 0 ? Math.max(0, baseShippingRate - shippingDiscountAmount) : 0;
      const totalExWithShipping = subtotalEx + shippingCostEx;
      const subtotalInc = ssIncFromEx(totalExWithShipping, taxRate);
      const vatAmount = subtotalInc - totalExWithShipping;

      // Totals rechts updaten
      const elSub = document.querySelector("[data-ss-subtotal-ex]");
      const elVat = document.querySelector("[data-ss-vat-amount]");
      const elTotInc = document.querySelector("[data-ss-total-inc]");
      const elTotEx = document.querySelector("[data-ss-total-ex]");

      if (elSub) elSub.textContent = ssMoney(subtotalEx, cfg);
      if (elVat) elVat.textContent = ssMoney(vatAmount, cfg);
      if (elTotInc) elTotInc.textContent = ssMoney(subtotalInc, cfg);
      if (elTotEx) elTotEx.textContent = ssMoney(totalExWithShipping, cfg);

      // Shipping bar + verzendkostenlabel updaten (zodat “gratis verzending” ook klopt)
      const shipText = document.querySelector("[data-ss-shipping-text]");
      if (shipText) {
        shipText.innerHTML = isEmptyFreeShippingCart
          ? '<span class="ss-cart-shipping-free">GRATIS</span>'
          : subtotalEx > 0
            ? ssShippingValueHtml(baseShippingRate, shippingFree, cfg, freeShippingProductDiscountActive ? freeShippingProductDiscountPercent : 0)
            : alwaysFreeShipping ? '<span class="ss-cart-shipping-free">GRATIS</span>' : "In checkout berekend";
        shipText.classList.toggle("is-free", shippingFree || freeShippingProductDiscountActive || isEmptyFreeShippingCart);
      }

      const savings = document.querySelector("[data-ss-shipping-savings]");
      const savingsAmount = document.querySelector("[data-ss-shipping-savings-amount]");
      if (savings) savings.classList.toggle("is-hidden", !hasShippingSaving);
      if (savingsAmount) savingsAmount.textContent = ssMoney(shippingDiscountAmount, cfg);

      if (alwaysFreeShipping || goal > 0) {
        const bar = document.querySelector("cart-shipping-bar.cart__shipping");
        if (bar) {
          // NIEUW: class voor groene styling
          bar.classList.toggle("is-free", shippingFree || isEmptyFreeShippingCart);

          const title = bar.querySelector(".cart__shipping__title");
          const progEl = bar.querySelector(".cart__shipping__bar");
          const actionNote = bar.querySelector("[data-ss-action-shipping-note]");
          const internationalActionNote = bar.querySelector("[data-ss-international-action-shipping-note]");

          if (title) {
            title.innerHTML = ssShippingTitleHtml({
              country: selectedShippingCountry,
              cfg,
              diff: goal - shippingEligibleSubtotal,
              free: shippingFree,
              empty: isEmptyCart,
              showActionShippingNote,
            });
          }
          if (progEl) {
            const p = shippingFree || isEmptyFreeShippingCart ? 1 : Math.max(0, Math.min(1, shippingEligibleSubtotal / goal));
            progEl.style.setProperty("--progress", p);
          }
          if (actionNote) {
            const actionNoteText = actionNote.querySelector("span");
            if (actionNoteText) {
              actionNoteText.textContent = showPartialProductShippingNote
                ? `${freeShippingProductDiscountPercent}% korting op verzending op geselecteerde producten BE.`
                : "GRATIS verzending op geselecteerde producten in NL.";
            }
            actionNote.classList.toggle("is-hidden", !(showActionShippingNote || showPartialProductShippingNote));
          }
          if (internationalActionNote) {
            internationalActionNote.classList.toggle("is-hidden", !showInternationalActionNote);
          }
        }
      }
    }

    initShippingCountrySelector();
    initFixedQtyUI();

    applyTierPricingUI();





    // Checkout blokkeren als MOQ faalt
    form.addEventListener('submit', function (e) {
      const seen = new Set();
      let ok = true;

      form.querySelectorAll('cart-quantity').forEach((cq) => {
        const pid = String(cq.dataset.productId || '');
        if (!pid) return;

        // Vaste aantallen check (per regel)
        const fixedAllowed = getFixedQtyOptionsFromCQ(cq);
        const currentQty = int(cq.dataset.currentQuantity);
        if (fixedAllowed.length && currentQty > 0 && !fixedAllowed.includes(currentQty)) {
          ok = false;
          showFixedQtyErrorForProduct(pid, fixedAllowed);
        }

        // MOQ check doen we op totaalaantal per product
        const minimumKey = cq.dataset.configuratorKey || pid;
        if (seen.has(minimumKey)) return;
        seen.add(minimumKey);

        const min = int(cq.dataset.minimumQuantity);
        const total = int(cq.dataset.currentTotal);

        if (min && total > 0 && total < min) {
          ok = false;
          showCartMinModal(
            `${min} stuks is de minimale afname. Pas de aantallen aan tot minimaal ${min} stuks in totaal.`
          );
        }
      });

      if (!ok) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
    });
  });
})();
